import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Logo from "../assets/infraLogo.jpg"

const GRNAllPrint = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [grandTotal, setGrandTotal] = useState("");
  const [error, setError] = useState(null);
  const location = useLocation();
  const { params } = location.state || {};

  useEffect(() => {
    if (!params) {
      setLoading(false);
      setError("No parameters provided");
      return;
    }

    const fetchReportData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://www.nissi-india.com/api/grn_rpt", { 
          params: params 
        });
        
        console.log("API Response:", response.data); // Debug log
        
        let data = response.data.data;

        setGrandTotal(response.data.grandTotal);
        setReportData(data);

      } catch (err) {
        console.error("Error fetching report data:", err);
        setError("Failed to fetch report data: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [params]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto bg-white p-8">
        <div className="text-center py-10">
          <div className="text-lg">Loading report...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto bg-white p-8">
        <div className="text-center py-10">
          <div className="text-lg text-red-600">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto bg-white p-8 print:p-4">
      {/* Header */}
      <div className="border-2 border-black mb-4">
        <div className="bg-gray-100 p-2 text-center font-bold text-lg border-b border-black">
          Main Report
        </div>
        
        {/* Company Info Section */}
        <div className="flex items-center p-4 border-b border-black">
          {/* Logo placeholder */}
          <div className="w-20 h-20 bg-black text-white flex items-center justify-center mr-6 text-xs font-bold">
            <div className="text-center">
              <img src={Logo} alt="Logo" className="logo"/>
            </div>
          </div>
          
          {/* Company Details */}
          <div className="flex-1 text-center">
            <h2 className="text-xl font-bold mb-1">Nissi Infotech</h2>
            <div className="text-sm">
              <div className="font-semibold">Nissi</div>
              <div className="font-semibold">CIVIL CONSTRUCTION</div>
              <div>3/42-12, Nagappa solony , kavundampalayal-620 ,Tamil Nadu.</div>
              <div>Phone No :9003744644 infraconsoft.implementa</div>
            </div>
          </div>
        </div>

        {/* Type field */}
        <div className="px-4 py-2 border-b border-black">
          <span className="font-semibold">Type - BO</span>
        </div>
      </div>

      {/* Table */}
      <div className="border border-black">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-black p-2 text-left font-semibold">S.No</th>
              <th className="border border-black p-2 text-left font-semibold">GRN No</th>
              <th className="border border-black p-2 text-left font-semibold">Date</th>
              <th className="border border-black p-2 text-left font-semibold">Supplier</th>
              <th className="border border-black p-2 text-left font-semibold">Inv No</th>
              <th className="border border-black p-2 text-left font-semibold">Inv Date</th>
              <th className="border border-black p-2 text-left font-semibold">Total Amount</th>
              <th className="border border-black p-2 text-left font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {reportData.map((row,index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="border border-black p-2">{index+1}</td>
                <td className="border border-black p-2 text-xs">
                  <div>{row.type && <div className="font-semibold">{row.type}</div>}
                  <div>{row.fld_grnno}</div></div>
                </td>
                <td className="border border-black p-2">{row.fld_date}</td>
                <td className="border border-black p-2 uppercase">{row.fld_suppliername}</td>
                <td className="border border-black p-2">{row.fld_InvNo}</td>
                <td className="border border-black p-2">{row.fld_InvoiceDate}</td>
                <td className="border border-black p-2 text-right font-medium">{row.TotalValueNew}</td>
                <td className="border border-black p-2 text-center">{row.Status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Grand Total */}
        <div className="border-t-2 border-black bg-gray-100 p-2 text-right">
          <span className="font-bold">Grand Total: {grandTotal}</span>
        </div>
      </div>

      {/* Print Button */}
      <div className="mt-4 text-center print:hidden">
        <button 
          onClick={() => window.print()} 
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Print Report
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body { margin: 0; }
          .print\\:hidden { display: none !important; }
          .print\\:p-4 { padding: 1rem !important; }
        }
      `}</style>
    </div>
  );
};

export default GRNAllPrint;